module.exports = __webpack_public_path__ + "media/images/package-free-0ca4abd7cfa5188993f696e6ed7aa92b.svg";